/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/
import React, { useContext, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Block from 'wfui-digital-core/es/Block';
import Translatable from 'wfui-digital-core/es/Translatable';
import ConnectedNavigationMenu from '../../navigation/mobile/ConnectedNavigationMenu';
import useBrand from 'wfui-digital-core/es/useBrand';
import useDevice from 'wfui-digital-core/es/useDevice';
import useStrings from 'wfui-digital-core/es/useStrings';
import PageContext from 'wfui-digital-core/es/PageContext';
import LogoBar from 'wfui-digital-core/es/MastheadLogoBar';
import { getClasses } from 'wfui-digital-core/es/lib';
import TriangleIcon from 'wfui-digital-core/es/TriangleIcon';
import globals from '../../../../lib/globals/globals';
import { NAVIGATION_MENU_ID_MORE, NAVIGATION_MENU_ID_PROFILE } from '../../../../lib/navigation/support/id';
import HamburgerIcon from '../../../icons/hamburger-icon/HamburgerIcon';
import ProfileMenuIcon from '../../../icons/profile-menu-icon/ProfileMenuIcon';
import useSettings from '../../../hooks/use-settings';
import ThePrivateBankLogo from '../the-private-bank-logo/ThePrivateBankLogo';
import SkipLink from './skip-link/SkipLink';
import MastheadBackArrowButton from './MastheadBackArrowButton';
import styles from './Masthead.less';

var Masthead = function Masthead(_ref) {
  var handleLogoClick = _ref.handleLogoClick,
      navigationDisabled = _ref.navigationDisabled;
  var mastheadRef = useRef();
  var brand = useBrand();
  var device = useDevice();

  var _useStrings = useStrings(),
      getString = _useStrings.getString;

  var _useContext = useContext(PageContext),
      setContainerRef = _useContext.setContainerRef;

  var _useSettings = useSettings(),
      useTPBBimUpdates = _useSettings.useTPBBimUpdates,
      hideMobileMastheadMenus = _useSettings.hideMobileMastheadMenus;

  var showMastheadBack = useSelector(function (_ref2) {
    var core = _ref2.core;
    return core.navigation.showMastheadBack;
  });

  var _useSelector = useSelector(function (_ref3) {
    var core = _ref3.core;
    return core.navigationMenu;
  }),
      activeMenuId = _useSelector.activeMenuId,
      menuOpen = _useSelector.menuOpen,
      isClosing = _useSelector.isClosing;

  useEffect(function () {
    setContainerRef('masthead')(mastheadRef.current);
  }, [setContainerRef]);
  var classes = ['masthead', (showMastheadBack || globals().backNavigationUrl) && 'showMastheadBack'];
  var mastheadClasses = getClasses({
    styles: styles,
    classes: classes,
    brand: brand,
    device: device
  });
  var profileTriangleClasses = getClasses({
    styles: styles,
    classes: ['triangle', 'profile', useTPBBimUpdates && 'useTPBBimUpdates', activeMenuId === 2 && menuOpen && !isClosing && 'active', showMastheadBack && 'showMastheadBack']
  });
  var navigationTriangleClasses = getClasses({
    styles: styles,
    classes: ['triangle', 'navigation', useTPBBimUpdates && 'useTPBBimUpdates', activeMenuId === 1 && menuOpen && !isClosing && 'active']
  });
  var profileMenuClasses = getClasses({
    styles: styles,
    classes: ['profileMenu', showMastheadBack && 'showMastheadBack'],
    brand: brand
  });
  var moreMenuClasses = getClasses({
    styles: styles,
    classes: ['moreMenu', useTPBBimUpdates && 'useTPBBimUpdates'],
    brand: brand
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, globals().useMobileStickyFooter && /*#__PURE__*/React.createElement(SkipLink, {
    skipLinkTargetId: "bnb-first-link",
    message: getString('global.skip.to.navigation') || ' '
  }), /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    center: true,
    justifyCenter: true,
    className: mastheadClasses,
    elementRef: mastheadRef
  }, /*#__PURE__*/React.createElement(MastheadBackArrowButton, null), !hideMobileMastheadMenus && /*#__PURE__*/React.createElement(ConnectedNavigationMenu, {
    menuId: NAVIGATION_MENU_ID_PROFILE,
    menuName: "profileMenu",
    alignLeft: true,
    className: profileMenuClasses
  }, /*#__PURE__*/React.createElement(ProfileMenuIcon, null), /*#__PURE__*/React.createElement(Translatable, {
    className: "visuallyHidden",
    id: "global.profile.menu"
  })), /*#__PURE__*/React.createElement(LogoBar, {
    handleClick: handleLogoClick,
    navigationDisabled: navigationDisabled,
    logoAltText: "Wells Fargo Online"
  }), !hideMobileMastheadMenus && /*#__PURE__*/React.createElement(ConnectedNavigationMenu, {
    menuId: NAVIGATION_MENU_ID_MORE,
    className: moreMenuClasses
  }, /*#__PURE__*/React.createElement(HamburgerIcon, null), /*#__PURE__*/React.createElement(Translatable, {
    className: "visuallyHidden",
    id: "global.navigation.menu"
  })), 'tpb' === brand && useTPBBimUpdates && /*#__PURE__*/React.createElement(TriangleIcon, {
    width: "15px",
    height: "7px",
    className: profileTriangleClasses
  }), 'tpb' === brand && useTPBBimUpdates && /*#__PURE__*/React.createElement(TriangleIcon, {
    width: "15px",
    height: "7px",
    className: navigationTriangleClasses
  })), brand === 'tpb' && /*#__PURE__*/React.createElement(ThePrivateBankLogo, null));
};

export default Masthead;